import * as styles from './NewbuildingRating.css';
import { IconToggleStarOn12 } from '@cian/ui-kit-design-tokens/icons';
import { UIHeading5 } from '@cian/ui-kit';

interface INewbuidlingRatingProps {
  reviewsRate: string;
  reviewsRateUrl: string;
}

export function NewbuildingRating(props: INewbuidlingRatingProps) {
  const { reviewsRate, reviewsRateUrl } = props;

  return (
    <a
      data-testid="newbuilding-rating"
      href={reviewsRateUrl}
      target="_blank"
      className={styles['container']}
      rel="noreferrer"
    >
      <IconToggleStarOn12
        color={reviewsRate !== '0' ? 'decorative-orange' : 'icon-secondary-disabled'}
      ></IconToggleStarOn12>
      <UIHeading5 color={reviewsRate !== '0' ? 'decorative-orange' : 'text-secondary-default'}>
        {reviewsRate}
      </UIHeading5>
    </a>
  );
}
